import { getAnnexDefinitionRoot } from '../../../store/rootSelector';
import { ApplicationState } from '../../../store/types';
import { AgencyDatasetField } from '../../datasets/store/types';
import { AnnexDefinition, AnnexDefinitionDB, InstanceAnnexDefinition, InstanceAnnexView } from './types';

export const getAnnexDefinitionModalOpen = (state: ApplicationState): boolean => getAnnexDefinitionRoot(state).annexDefinitionModalOpen;

export const getAnnexBuilderModalOpen = (state: ApplicationState): boolean => getAnnexDefinitionRoot(state).annexBuilderModalOpen;

export const getIsPublishing = (state: ApplicationState): boolean => getAnnexDefinitionRoot(state).isPublishing;

export const getAnnexDefinition = (state: ApplicationState): AnnexDefinition | null => getAnnexDefinitionRoot(state).annexDefinition;

export const getAvailableFields = (state: ApplicationState): AgencyDatasetField[] => getAnnexDefinitionRoot(state).availableFields;

export const getAllAnnexDefinitions = (state: ApplicationState): AnnexDefinitionDB[] => getAnnexDefinitionRoot(state).publishedAnnexDefinitions;

export const getCurrentInstanceAnnexDefinitions = (state: ApplicationState): InstanceAnnexDefinition[] => getAnnexDefinitionRoot(state).currentInstanceAnnexDefinitions;

export const getSavedInstanceAnnexDefinitions = (state: ApplicationState): InstanceAnnexDefinition[] => getAnnexDefinitionRoot(state).savedInstanceAnnexDefinitions;

export const getInstanceAnnexDefinitionsUpdated = (state: ApplicationState): boolean => getAnnexDefinitionRoot(state).instanceAnnexDefinitionsUpdated;

export const getInstanceAnnexView = (state: ApplicationState): InstanceAnnexView => getAnnexDefinitionRoot(state).instanceAnnexView;

export const getSelectedInstanceIndex = (state: ApplicationState): number => getAnnexDefinitionRoot(state).selectedInstanceIndex;
